import { useEffect } from 'react'
import { create } from 'zustand'

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    /** The page's name in the browser tab, e.g. "Purchase Orders". */
    title?: string
    /** On a phone the page fills the screen: no dashboard top bar, page padding or footer. */
    phoneFullScreen?: boolean
  }
}

const APP_NAME = 'USA-RS'

/** "PO 10423" → "PO 10423 · USA-RS"; no page title → "USA-RS". */
export function formatDocumentTitle(title?: string | null): string {
  const page = title?.trim()
  return page ? `${page} · ${APP_NAME}` : APP_NAME
}

/** The open record's name, set by detail pages once their data loads. */
export const useRecordTitle = create<{ title: string | null }>(() => ({ title: null }))

/** Names the browser tab after the record a detail page shows, e.g. `usePageTitle(`PO ${po.po_number}`)`. */
export function usePageTitle(title: string | null | undefined) {
  useEffect(() => {
    const page = title?.trim()
    if (!page) return
    useRecordTitle.setState({ title: page })
    return () => {
      if (useRecordTitle.getState().title === page) useRecordTitle.setState({ title: null })
    }
  }, [title])
}
